<template>
  <div class="xl:border-black xl:border-r">
    <div class="px-0 xl:px-4 pt-6 pb-45 text-bygg-blue font-demibold text-sm">
      <div class="w-full relative">
        <div name="forhandlere" v-on:click="openRetailers($event)" class="forhandlere pr-66 pl-90 w-full xl:border xl:border-bygg-blue h-8 xl:px-3 mb-3 font-demibold overflow-hidden cursor-pointer absolute z-10 bg-white">
          <div default value="velg-forhandler" class="pointer-events-none pl-3 xl:pl-0" style="padding-top: 6px">
            {{ selectedRetailer }}
          </div>
          <div class="px-3 font-medium text-xs leading-5 pt-6 xl:pt-12 -z-10 block xl:hidden">
            <div v-for="item in retailersList" :key="item.id" v-show="selectedRetailer === item.title">
              <p>{{ item.address }}</p>
              <div class="flex flex-col relative cursor-pointer hover:underline" v-on:click="openOpeningHours()">
                <div class="" v-for="day in item.openingHours" :key="day.day">
                  <p class="flex" v-show="getWeekDay(new Date().getDay()) === day.day">
                    <span>Åpent i dag&nbsp;</span><span>{{ day.hours }}</span>
                  </p>
                </div>
                <div id="open-hours-arrow" class="open-hours-arrow absolute left-160 top-7 pointer-events-none transform">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11.743" height="6.799" viewBox="0 0 11.743 6.799">
                    <path id="np_arrow_1920916_000000" d="M.927,11.743,0,10.8,4.932,5.871,0,.94.927,0,6.8,5.872Z" transform="translate(11.743) rotate(90)" fill="#0A1EBE" />
                  </svg>
                </div>
              </div>
              <div class="opening-hours hidden">
                <div v-for="day in item.openingHours" :key="day.day">
                  <div class="">
                    <p>
                      <span>{{ day.day }}&nbsp;</span><span>{{ day.hours }}</span>
                    </p>
                  </div>
                </div>
              </div>
              <a class="hover:underline block" :href="'mailto:' + item.email">{{ item.email }}</a>
              <a class="hover:underline block" :href="'tel:' + item.phone">{{ item.phone }}</a>
            </div>
          </div>
          <div class="px-3 mt-2 relative">
            <div class="absolute top-25 xl:top-0 left-0 h-40 w-full flex justify-start align-middle border border-bygg-blue">
              <input v-model="searchInput" v-on:keyup="searchRetailer()" type="number" class="appearance-none text-sm pl-4" max="9999" placeholder="Skriv inn postnummer" />
            </div>
          </div>
          <div id="retailersList" v-show="!showResult" class="pt-90 xl:pt-12 pb-16">
            <template v-for="(item, index) in retailersList">
              <template v-if="index == 0">
                <div :key="index" v-on:click="openDistrict($event)" :data-districtId="item.district" class="pt-3 overflow-hidden h-40 cursor-pointer text-black hover:text-bygg-blue" >
                  <div :key="index" class="relative flex justify-between border-black border-t pt-2 pl-4 pointer-events-none district">
                    {{ item.district }}
                    <span class="numberOfRetailers pr-10">0</span>
                    <div class="arrow absolute right-16 top-14 pointer-events-none transform">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11.743" height="6.799" viewBox="0 0 11.743 6.799">
                        <path id="np_arrow_1920916_000000" d="M.927,11.743,0,10.8,4.932,5.871,0,.94.927,0,6.8,5.872Z" transform="translate(11.743) rotate(90)" fill="#0A1EBE" />
                      </svg>
                    </div>
                  </div>
                  <p :key="item" class="pl-8 pt-2 text-black font-medium retailer hover:text-bygg-blue cursor-pointer" :data-district="item.district" :data-postNumber="item.postNumber" :value="item.title" v-on:click="selectRetailer($event, item.title, item.slug)">
                    {{ item.title }}
                  </p>
                </div>
              </template>
              <template v-else-if="retailersList[index].district != retailersList[index - 1].district" >
                <div :key="index" v-on:click="openDistrict($event)":data-districtId="item.district" class="pt-3 overflow-hidden h-40 cursor-pointer text-black hover:text-bygg-blue" >
                  <div :key="index" class="relative flex justify-between border-black border-t pt-2 pl-4 pointer-events-none district">
                    {{ item.district }}
                    <span class="numberOfRetailers pr-10">0</span>
                    <div class="arrow absolute right-16 top-14 pointer-events-none transform">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11.743" height="6.799" viewBox="0 0 11.743 6.799">
                        <path id="np_arrow_1920916_000000" d="M.927,11.743,0,10.8,4.932,5.871,0,.94.927,0,6.8,5.872Z" transform="translate(11.743) rotate(90)" fill="#0A1EBE" />
                      </svg>
                    </div>
                  </div>
                  <p :key="item" class="pl-8 pt-2 text-black font-medium retailer hover:text-bygg-blue cursor-pointer" :data-district="item.district" :data-postNumber="item.postNumber" :value="item.title" v-on:click="selectRetailer($event, item.title, item.slug)">
                    {{ item.title }}
                  </p>
                </div>
              </template>
              <template v-else>
                <p :key="item" class="pl-8 pt-2 text-black font-medium retailer hover:text-bygg-blue cursor-pointer retailer-no-parent" :data-district="item.district" :data-postNumber="item.postNumber" :value="item.title" v-on:click="selectRetailer($event, item.title, item.slug)">
                  {{ item.title }}
                </p>
              </template>
            </template>
          </div>
          <div id="retailerResult" v-show="showResult" class="pt-90 md:pt-12 pb-16">
            <div v-for="i in retailersListResult" :key="i.id">
              <p class="pl-8 pt-2 text-black font-medium retailer hover:text-bygg-blue cursor-pointer" v-on:click="selectRetailer($event, i.title, i.slug)" :data-item="i.title" :value="i.title">
                {{ i.title }}
              </p>
            </div>
          </div>
        </div>
        <div id="dropdown-retailer-arrow" class="dropdown-retailer-arrow absolute right-85 xl:right-16 top-14 pointer-events-none transform z-10">
          <svg xmlns="http://www.w3.org/2000/svg" width="11.743" height="6.799" viewBox="0 0 11.743 6.799">
            <path id="np_arrow_1920916_000000" d="M.927,11.743,0,10.8,4.932,5.871,0,.94.927,0,6.8,5.872Z" transform="translate(11.743) rotate(90)" fill="#0A1EBE" />
          </svg>
        </div>
        <div class="px-3 font-medium text-xs leading-5 pt-12 -z-10 hidden xl:block">
          <div v-for="item in retailersList" :key="item.id" v-show="selectedRetailer === item.title">
            <p>{{ item.address }}</p>
            <div class="flex flex-col relative cursor-pointer hover:underline" v-on:click="openOpeningHours()">
              <div class="" v-for="day in item.openingHours" :key="day.day">
                <p class="flex" v-show="getWeekDay(new Date().getDay()) === day.day">
                  <span>Åpent i dag&nbsp;</span><span>{{ day.hours }}</span>
                </p>
              </div>
              <div id="open-hours-arrow" class="open-hours-arrow absolute right-45 top-7 pointer-events-none transform">
                <svg xmlns="http://www.w3.org/2000/svg" width="11.743" height="6.799" viewBox="0 0 11.743 6.799">
                  <path id="np_arrow_1920916_000000" d="M.927,11.743,0,10.8,4.932,5.871,0,.94.927,0,6.8,5.872Z" transform="translate(11.743) rotate(90)" fill="#0A1EBE" />
                </svg>
              </div>
            </div>
            <div class="opening-hours hidden">
              <div v-for="day in item.openingHours" :key="day.day">
                <div class="">
                  <p>
                    <span>{{ day.day }}&nbsp;</span><span>{{ day.hours }}</span>
                  </p>
                </div>
              </div>
            </div>
            <a class="hover:underline block" :href="'mailto:' + item.email">{{ item.email }}</a>
            <a class="hover:underline block" :href="'tel:' + item.phone">{{ item.phone }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div>{{ myLocation }}</div>
    <div v-for="item in distances" :key="item.id">
        <h3>{{ item.name }}</h3>
        <p>{{ item.lat }} - {{ item.lng }}</p>
        <p>{{ item.m }} meter</p>
        <p>{{ item.km }} km</p>
    </div> -->
  </div>
</template>

<script>
import LatLon from "geodesy/latlon-spherical"; // "geodesy": "2.2.1",
import { sort } from "ramda";
export default {
  props: {
    retailersList: {
      type: Array,
      required: true,
    },
    districts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      myLocation: {},
      distances: [],
      selectedRetailer: "Velg forhandler",
      searchInput: null,
      searchResult: [],
      showResult: false,
      retailersListResult: [],
      locations: [
        {
          id: 1,
          name: "Ørsta skisenter",
          lat: 62.1849287,
          lng: 6.1527851,
        },
        {
          id: 2,
          name: "Nordre vartdal",
          lat: 62.3220708,
          lng: 6.1388409,
        },
        {
          id: 3,
          name: "Oslo",
          lat: 59.8938364,
          lng: 10.7150777,
        },
        {
          id: 4,
          name: "Ålesund",
          lat: 62.4680432,
          lng: 6.1714092,
        },
      ],
      error: undefined,
    };
  },
  watch: {
    selectedRetailer(newSelected) {
      localStorage.selectedRetailer = newSelected;
    },
  },
  methods: {
    searchRetailer() {
      if (this.searchInput.length > 0) {
        this.retailersListResult = [];

        this.retailersListResult = sort((a, b) => {
          return Math.abs(this.searchInput - a.postNumber) - Math.abs(this.searchInput - b.postNumber);
        })(this.retailersList);
        this.retailersListResult.splice(3);
        this.showResult = true;
      } else {
        this.retailersListResult = [];
        this.showResult = false;
      }
    },
    openOpeningHours() {
      document.querySelectorAll(".opening-hours").forEach((el) => {
        el.classList.toggle("hidden");
      });
      document.querySelectorAll(".open-hours-arrow").forEach((el) => {
        el.classList.toggle("rotate-180");
      });
    },
    openRetailers(e) {
      var element = document.querySelectorAll(".forhandlere");
      document.querySelectorAll(".forhandlere").forEach((el) => {
        if (el == e.target) {
          el.classList.toggle("h-8");
          if (!el.classList.contains("h-8")) {
            el.style.maxHeight = el.clientHeight + 10 + "px";
            el.style.overflowY = "scroll";
          } else {
            el.style.maxHeight = "unset";
            el.style.overflowY = "unset";
          }
          document.querySelectorAll(".dropdown-retailer-arrow").forEach((a) => {
            a.classList.toggle("rotate-180");
          });
          document.querySelector("#top-nav").classList.add("hidden");
          document.querySelector("#nav-toggle").classList.remove("nav-open");
        }
      });
    },
    openDistrict(e) {
      if (!e.target.classList.contains("retailer")) {
        e.target.classList.toggle("h-40");
        e.target.children[0].classList.toggle("text-bygg-blue");
        e.target.querySelector(".arrow").classList.toggle("rotate-180");
      }
    },
    selectRetailer(e, title, slug) {
      this.selectedRetailer = title;
      localStorage.selectedRetailer = title;
      this.searchResult = [];
      this.showResult = false;
      document.querySelectorAll(".forhandlere").forEach((el) => {
        el.classList.add("h-8");
      });
      document.querySelectorAll(".dropdown-retailer-arrow").forEach((a) => {
        a.classList.toggle("rotate-180");
      });
      var location = window.location;
      location.href = location.protocol + "//" + location.host + "/" + "forhandlere/" + slug;
    },
    getWeekDay(id) {
      var day = "";
      switch (id) {
        case 1:
          day = "Mandag";
          break;
        case 2:
          day = "Tirsdag";
          break;
        case 3:
          day = "Onsdag";
          break;
        case 4:
          day = "Torsdag";
          break;
        case 5:
          day = "Fredag";
          break;
        case 6:
          day = "Lørdag";
          break;
        case 7:
          day = "Søndag";
          break;
      }
      return day;
    },
    calcDistances(pos) {
      let distances = [];
      if (pos) {
        const p1 = new LatLon(pos.lat, pos.lng);
        for (let index = 0; index < this.locations.length; index++) {
          const r = this.locations[index];
          const p2 = new LatLon(this.locations[index].lat, this.locations[index].lng);
          const distanceMeter = p1.distanceTo(p2).toFixed(2);
          const distanceKilometer = (distanceMeter / 1000).toFixed(2);
          this.locations[index].m = distanceMeter;
          this.locations[index].km = distanceKilometer;
          distances.push(r);
        }
      }
      this.distances = distances;
    },
  },
  mounted() {
    // CHECK IF COOKIE EXIST
    if (localStorage.selectedRetailer) {
      this.selectedRetailer = localStorage.selectedRetailer;
    }
    if (window.innerWidth >= 1280) {
      var retailerNoParents = document.querySelectorAll(".retailer-no-parent");
      retailerNoParents.forEach((el) => {
        el.previousElementSibling.appendChild(el);
      });
    } else {
      var retailerNoParents = document.querySelectorAll("#app_id_0 .retailer-no-parent");
      retailerNoParents.forEach((el) => {
        //el.previousElementSibling.previousElementSibling.previousElementSibling.append(el);
        document.querySelector(`#app_id_0 [data-districtid='${el.dataset.district}']`).appendChild(el);
      });
    }

    var districts = document.querySelectorAll(".district");
    districts.forEach((el) => {
      el.querySelectorAll(".numberOfRetailers")[0].innerText = el.parentElement.children.length - 1;
    });

    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(
    //     (position) => {
    //       this.myLocation = {
    //         lat: position.coords.latitude,
    //         lng: position.coords.longitude,
    //       };
    //       this.calcDistances(this.myLocation);
    //     },
    //     (error) => {
    //       this.error = error;
    //     }
    //   );
    // }
  },
};
</script>
